import AgencyMaintainService from "../../agency_maintain/service";
import {handleResponse} from "./handleResponse";
import SmartEnergyService from "../../smart_energy/service";


export const RUN_MONITOR_COMPARE_ANALYZE_TABLE_IS_LOADING = "RUN_MONITOR_COMPARE_ANALYZE_IS_LOADING"; // 对比分析图表是否加载中
export const RUN_MONITOR_COMPARE_ANALYZE_SET_SELECTED_NODE = "RUN_MONITOR_COMPARE_ANALYZE_SET_SELECTED_NODE"; // 设置选择的树节点
export const RUN_MONITOR_COMPARE_ANALYZE_SET_CURVES_DATA = "RUN_MONITOR_COMPARE_ANALYZE_SET_CURVES_DATA"; // 设置曲线数据
export const RUN_MONITOR_COMPARE_ANALYZE_ADD_CHOSEN_ITEM = "RUN_MONITOR_COMPARE_ANALYZE_ADD_CHOSEN_ITEM"; // 添加对比分析项
export const RUN_MONITOR_COMPARE_ANALYZE_DELETE_CHOSEN_ITEM = "RUN_MONITOR_COMPARE_ANALYZE_DELETE_CHOSEN_ITEM"; // 移除已选择项
export const RUN_MONITOR_COMPARE_ANALYZE_SET_TREE_ID = "RUN_MONITOR_COMPARE_ANALYZE_SET_TREE_ID"; // 设置当前树id
export const RUN_MONITOR_COMPARE_ANALYZE_RESET_CURVES_DATA = "RUN_MONITOR_COMPARE_ANALYZE_RESET_CURVES_DATA"; // 重置曲线数据
/**
 * 获取历史曲线
 * @param type 类型 0: 日  1:月  2: 年
 * @param params 请求参数
 */
export const getCurves = (type, params, item) => {
    return (dispatch, getState) => {
        // 配电
        if(getState().agencyMaintainData.compareAnalyzeData.treeId == "DIST_OPS_MGMT_TREE"){
            handleResponse(AgencyMaintainService.runMonitorCompareAnalyzeService.getCurves(type, params), (jsonData) => {
                dispatch({
                    type: RUN_MONITOR_COMPARE_ANALYZE_SET_CURVES_DATA,
                    data: jsonData,
                    item: item
                })
            }, "获取数据失败", (flag) => dispatch(setCurvesTableIsLoading(flag)));
        }else if(getState().agencyMaintainData.compareAnalyzeData.treeId == "CONS_ENERGY_MGMT_TREE"){
            handleResponse(SmartEnergyService.energyCompareAnalyzeService.getCurves(type, params), (jsonData) => {
                dispatch({
                    type: RUN_MONITOR_COMPARE_ANALYZE_SET_CURVES_DATA,
                    data: jsonData,
                    item: item
                })
            }, "获取数据失败", (flag) => dispatch(setCurvesTableIsLoading(flag)));
        }
    }
}

/**
 * 设置选择的节点
 * @param superiorId 编码
 * @param title 名称
 */
export const selectedNode = (superiorId, title) => {
    return {
        type: RUN_MONITOR_COMPARE_ANALYZE_SET_SELECTED_NODE,
        superiorId: superiorId,
        title: title
    }
}

/**
 * 设置图标是否加载中
 */
const setCurvesTableIsLoading = (isLoading) => {
    return {
        type: RUN_MONITOR_COMPARE_ANALYZE_TABLE_IS_LOADING,
        isLoading: isLoading
    }
}

/**
 * 添加对比分析项
 * @param item
 */
export const addChosenItem = (item) => {
    return {
        type: RUN_MONITOR_COMPARE_ANALYZE_ADD_CHOSEN_ITEM,
        item: item
    }
}
/**
 * 移除已选择项目
 * @param itemId 项id
 */
export const deleteChosenItem = (itemId) => {
    return {
        type: RUN_MONITOR_COMPARE_ANALYZE_DELETE_CHOSEN_ITEM,
        itemId: itemId
    }
}

/**
 * 设置当前树id
 * @param treeId 树id
 */
export const setCurrentTreeId = (treeId) => {
    return {
        type: RUN_MONITOR_COMPARE_ANALYZE_SET_TREE_ID,
        treeId: treeId
    }
}
/**
 * 重置曲线数据
 * @returns {{type: *}}
 */
export const resetCurveData = () => {
    return {
        type: RUN_MONITOR_COMPARE_ANALYZE_RESET_CURVES_DATA,
    }
}

